import React from 'react'
import { Button, LinkButton } from '@/atoms/Button'
import { SceneIcon } from '@/atoms/Icons/SceneIcon'
import { LegacyImage as Image } from '@/atoms/LegacyImage'
import { AsH2, AsP, CaptionMD, CaptionSM, ParagraphLG, ParagraphSM, TitleLG } from '@/atoms/Text'
import { useLoginUrl } from '@/utils/auth-utils'

interface ClaimInstructionsProps {
  onClaim: () => void
  onClose: () => void
  isLoggedIn: boolean
}

export const ClaimInstructions: React.FC<ClaimInstructionsProps> = ({ onClaim, onClose, isLoggedIn }) => {
  const { loginUrl, trackLoginStarted } = useLoginUrl()

  return (
    <div className="text-center">
      <TitleLG as={AsH2} className="mb-4">
        Season 3 Finale Gift
      </TitleLG>
      <CaptionMD className="text-gray-500">Introducing Angel Collectible Scenes</CaptionMD>

      <div className="my-8">
        <Image alt="Collectible Scenes" src="/v1675479844/scene-preview.webp" height={336} width={600} />
      </div>

      <div className="mt-4 flex flex-col items-center gap-4">
        <TitleLG as={AsH2}>Who gets a gift?</TitleLG>

        <div className="text-center">
          <ParagraphLG as={AsP} weight="semibold" className="flex items-center justify-center gap-1">
            <SceneIcon size={20} color1="gray-950" color2="collectible-blue" className="inline" />
            <span className="text-collectible-blue">Collectible Scene</span>
          </ParagraphLG>
          <ParagraphSM>If you Paid it Forward or Invested in The Chosen</ParagraphSM>
        </div>
        <div className="text-center">
          <ParagraphLG as={AsP} weight="semibold" className="flex items-center justify-center gap-1">
            <SceneIcon size={20} color1="gray-950" color2="collectible-gold" className="inline" />{' '}
            <span className="text-collectible-gold">Golden Scene</span>
          </ParagraphLG>
          <ParagraphSM as={AsP}>If you are Paying it Forward monthly</ParagraphSM>
        </div>
        <CaptionSM as={AsP} className="my-8 text-gray-500">
          Scenes will be distributed in May at our Illuminate 2023 Event.
        </CaptionSM>
      </div>
      <div className="flex flex-col justify-end gap-4 md:flex-row">
        <Button variant="gray-900" onClick={onClose} className="justify-center">
          Close
        </Button>
        {isLoggedIn ? (
          <Button variant="white" className="justify-center" onClick={onClaim}>
            <SceneIcon color1="white" color2="black" className="mr-1" /> Reserve a scene
          </Button>
        ) : (
          <LinkButton
            href={loginUrl}
            variant="white"
            className="justify-center"
            onClick={() => trackLoginStarted('claim-a-scene-instructions')}
          >
            <SceneIcon color1="white" color2="black" className="mr-1" /> Login to reserve a scene
          </LinkButton>
        )}
      </div>
    </div>
  )
}
